// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"83":"283765fb","123":"7b0c12c0","189":"10288943","190":"d8ec0154","357":"7695dce5","762":"5eb5b7ae","794":"09a68b8b","854":"da4e12d2","865":"bf44c0bf","915":"6fb4a13e","933":"69f420a0"}[chunkId] + ".js";
};